<template lang="html">
  <div class="">
    <SalesSubheader />
    <p>Bills</p>
    <BillsTable />
  </div>
</template>

<script>
import SalesSubheader from '../../components/SalesComponents/SalesSubheader';
import BillsTable from '../../components/SalesComponents/BillsTable';
export default {
  name: "BillsPage",
  components: {
    SalesSubheader,
    BillsTable
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
